import {AddressBaseValidation} from "@/classes/global/AddressBaseValidation";

export class PickStockValidation extends AddressBaseValidation {

    constructor() {

        super();
    }
}